var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { XbpmActionType } from '../../models/xbpm.enums';
import { isFormElement, ExtraActionType, } from '../../models/form.types';
import { FormRenderer } from './form-renderer';
import { FormEventsHandler } from './form-events-handler';
import { FormContext } from './form-context';
import { BehaviorSubject } from 'rxjs';
import { takeUntil, filter, throttleTime } from 'rxjs/operators';
import { isNotNil } from '../utils/_.utils';
var FormHandler = /** @class */ (function () {
    function FormHandler(controls, containers, baseLayout) {
        var _this = this;
        //
        this.throttledEvents = new Map();
        // handle ui events
        this.handleEventWithThrottle = function (duration, handler) {
            // handle target events
            var getEvent$ = function (targetKey) {
                var event$ = _this.throttledEvents.get(targetKey);
                if (!event$) {
                    event$ = new BehaviorSubject(null);
                    _this.throttledEvents.set(targetKey, event$);
                    event$
                        .pipe(filter(isNotNil), throttleTime(duration), takeUntil(_this.context.destroy$))
                        .subscribe(handler);
                }
                return event$;
            };
            // handle events
            var handlerWithThrottle = function (event) {
                if (isFormElement(event.target)) {
                    var event$ = getEvent$(event.target.id + "@" + event.type);
                    event$.next(event);
                }
                else {
                    handler(event);
                }
            };
            var events$ = new BehaviorSubject(null);
            events$.pipe(filter(isNotNil), takeUntil(_this.context.destroy$)).subscribe(handlerWithThrottle);
            //
            return function (event) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.context.afterChanges()];
                        case 1:
                            _a.sent();
                            events$.next(event);
                            return [2 /*return*/];
                    }
                });
            }); };
        };
        this.handleClick = function (onFormEvent) { return function (event) { return __awaiter(_this, void 0, void 0, function () {
            var target, evt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.context.afterChanges()];
                    case 1:
                        _a.sent(); // wait curr form changes
                        target = isFormElement(event.target)
                            ? this.context.findFormulaDefinition(event.target.id)
                            : event.target;
                        if (!target.frontFormulas.formulaFrontClick) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.eventsHandler.handleLocalClick({ type: event.type, context: this.context, target: target })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.context.afterChanges()];
                    case 3:
                        _a.sent(); // wait click local changes
                        _a.label = 4;
                    case 4:
                        // handle click request
                        if (isFormElement(target) && target.frontFormulas.formulaFrontRequest) {
                            evt = {
                                type: event.type,
                                target: target,
                                context: this.context,
                            };
                            this.eventsHandler.handleApiClick(evt);
                            onFormEvent(evt);
                        }
                        return [2 /*return*/];
                }
            });
        }); }; };
        this.handleAction = function (onFormEvent) { return function (event) { return __awaiter(_this, void 0, void 0, function () {
            var evt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.context.afterChanges()];
                    case 1:
                        _a.sent();
                        evt = {
                            type: event.type,
                            target: this.context.findFormulaDefinition(event.target.id),
                            context: this.context,
                        };
                        this.eventsHandler.handleApiClick(evt);
                        onFormEvent(evt);
                        return [2 /*return*/];
                }
            });
        }); }; };
        this.handleUIEvent = function (onFormEvent) { return function (event) {
            switch (event.type) {
                case ExtraActionType.ERROR:
                case ExtraActionType.LOADING:
                    onFormEvent({
                        type: event.type,
                        target: _this.context.findFormulaDefinition(event.target.id),
                        context: _this.context,
                        data: event.data,
                    });
                    return;
                case XbpmActionType.FRONT_CLICK:
                    return _this.handleClickWithThrottle(event);
                default:
                    return _this.handleActionWithThrottle(event); // handle etc XbpmActionType actions
            }
        }; };
        // init form context
        this.context = new FormContext({ validateOnBlur: true, validateOnChange: true });
        // init elements renderer
        this.renderer = new FormRenderer(this.context, controls, containers, baseLayout);
        // init internal events handler
        this.eventsHandler = new FormEventsHandler(this.context);
    }
    // render form elements
    FormHandler.prototype.renderForm = function (onFormEvent, definition) {
        if (!definition) {
            return null;
        }
        var ctxUpdated = this.context.initWithDefinition(definition);
        if (ctxUpdated) {
            this.handleClickWithThrottle = this.handleEventWithThrottle(FormContext.CHANGE_DEBOUNCE_TIME, this.handleClick(onFormEvent));
            this.handleActionWithThrottle = this.handleEventWithThrottle(FormContext.CHANGE_DEBOUNCE_TIME, this.handleAction(onFormEvent));
        }
        var handleUIEvent = this.handleUIEvent(onFormEvent);
        return this.renderer.renderRoot(handleUIEvent);
    };
    // destoy handler
    FormHandler.prototype.destroy = function () {
        this.context.destroy();
        this.clean();
    };
    FormHandler.prototype.clean = function () {
        this.context.clean();
        this.renderer.clean();
    };
    return FormHandler;
}());
export { FormHandler };
//# sourceMappingURL=form-handler.js.map